<script lang="ts">
	import EditButton from './EditButton.svelte';
	import { _ } from 'svelte-i18n';
	import { browser } from '$app/environment';

	export let title = '';
	export let contents: string;

	let success = false;

	function onClick() {
		window.navigator.clipboard.writeText(contents);
		success = true;
		setTimeout(() => (success = false), 2000);
	}
</script>

{#if browser && window.navigator.clipboard}
	<EditButton
		nounText={title}
		verbText={success
			? $_('components.clipboardButton.verbSuccess')
			: $_('components.clipboardButton.verb')}
		on:click={onClick}
		disabled={success}
	/>
{/if}
